import React, { Fragment, useEffect, useState } from 'react';
import { add as addToCartService } from '../Services/Cart.service';
import { add as addToOffer } from '../Services/Offer.service';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';
import {
  receive,
  loadError,
  triggerAddToCartAnimation,
} from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { useDispatch, useSelector } from 'react-redux';
import QuantityInput from './QuantityInput';
import { FileText, ShoppingCartSimple, User, Info } from 'phosphor-react';
import colors from 'Exports/colors.scss';
import { Tooltip } from '@material-ui/core';
import { translate } from '../Services/translation';
import { selectWheelBuilderProduct } from '../Actions/WheelBuilder.action';
import {
  addItemToOffer as addItemToOfferAction,
  toggleOfferMenu,
} from '../Actions/Offers.action';
import { addNotification } from '../Services/Notification.service';
import { showLogin } from '../Actions/Login.action';

const BuyButton = ({
  label,
  articleNumber,
  quantityFieldId,
  href,
  cssClass,
  disabled,
  onClick,
  quantity,
  userIsAuthenticated,
  showQuantityInputButtons = true,
}) => {
  const dispatch = useDispatch();
  const { isWheelBuilder } = useSelector((state) => state.productsView);
  const { activeOfferSystemId } = useSelector((state) => state.offers);
  const { quantity: priceDisplayQuantity } = useSelector(
    (state) => state.priceDisplayQuantity
  );
  const [internalQuantity, setInternalQuantity] = useState(quantity ?? 1);

  useEffect(() => quantity && setInternalQuantity(quantity), [quantity]);
  useEffect(
    () => priceDisplayQuantity && setInternalQuantity(priceDisplayQuantity),
    [priceDisplayQuantity]
  );

  const addItemToOffer = (offerId) => {
    dispatch(
      addItemToOfferAction(offerId, {
        articleNumber,
        quantity: internalQuantity,
      })
    );
  };

  const addToOfferClick = () => {
    if (activeOfferSystemId) {
      addItemToOffer(activeOfferSystemId);
    } else {
      dispatch(
        // Open offer menu, then on offer clicked, close the menu and trigger this method again to add the item
        toggleOfferMenu(true, (offer) => {
          addItemToOffer(offer.id);
          dispatch(toggleOfferMenu(false));
        })
      );

      addNotification({
        type: 'info',
        text: translate('offer-modal.add-to-offer.select-an-offer-first'),
      });
    }
  };

  if (!userIsAuthenticated) {
    return (
      <div className="buy-button--wrapper">
        <Tooltip title={translate('product.login-to-proceed')}>
          <button
            className="buy-button btn btn--primary"
            onClick={() => dispatch(showLogin(true))}
          >
            {label}
          </button>
        </Tooltip>
      </div>
    );
  }

  return (
    <div className="buy-button--wrapper">
      {!isWheelBuilder && articleNumber && (
        <QuantityInput
          value={internalQuantity}
          onQuantityIncrease={() =>
            setInternalQuantity(parseInt(internalQuantity) + 1)
          }
          onQuantityDecrease={() => {
            if (internalQuantity > 1) {
              setInternalQuantity(parseInt(internalQuantity) - 1);
            }
          }}
          onChange={(quantity) => setInternalQuantity(quantity)}
          showButtons={showQuantityInputButtons}
        />
      )}
      {!isWheelBuilder && (
        <>
          {articleNumber ? (
            <Tooltip title={label}>
              <span style={{ display: 'flex', flex: 1 }}>
                <button
                  className="buy-button btn btn--primary"
                  disabled={disabled}
                  onClick={() =>
                    onClick({ articleNumber, quantity: internalQuantity })
                  }
                >
                  <ShoppingCartSimple size={20} />
                  <span className="buy-button--label">{label}</span>
                </button>
              </span>
            </Tooltip>
          ) : (
            <a
              className="buy-button btn btn--primary buy-button--not-buyable"
              href={href}
            >
              <Info size={20} />
              {label}
            </a>
          )}
          {articleNumber && !disabled && (
            <a className="buy-button--copy" onClick={addToOfferClick}>
              <FileText color={colors['primary']} size={20} />
            </a>
          )}
        </>
      )}
      {isWheelBuilder && (
        <>
          <button
            className="buy-button btn btn--primary"
            onClick={() =>
              articleNumber &&
              onClick({ articleNumber, quantity: internalQuantity })
            }
            disabled={disabled}
          >
            {translate('general.select')}
          </button>
        </>
      )}
    </div>
  );
};

const StyledButton = (props) => {
  const { isWheelBuilder } = useSelector((state) => state.productsView);
  const { generalRowNote } = useSelector((state) => state.cart);

  const dispatch = useDispatch();
  const onClick = async ({ articleNumber, quantity }) => {
    if (isWheelBuilder) {
      // Select product
      dispatch(selectWheelBuilderProduct(articleNumber));
    } else {
      // Normal buy button
      try {
        const cart = await addToCartService({
          articleNumber,
          quantity,
          note: generalRowNote,
        });
        dispatch(receive(cart));
        dispatch(triggerAddToCartAnimation());
        return true;
      } catch (ex) {
        dispatch(catchError(ex, (error) => loadError(error)));
        return false;
      }
    }
  };
  const Button = withReactiveStyleBuyButton(BuyButton, onClick, 'buy-button');
  return <Button {...props} />;
};

export default StyledButton;
